/**
 * Created by Tiger on 23/03/2022.
 */
import React from 'react';
import styled from '@emotion/styled';
import {MoreOutlined as More} from '@ant-design/icons';
import {Pagination} from 'antd';
import i18n from 'i18next';

export const MoreOutlined = styled(More)`
  cursor: pointer;
`;

export const TablePagination = ({ total = 0, currentPage = 1, pageSize = 50,refresh=()=>{}, ...restProps }) => {
  return <Pagination
    total={ total }
    current={ currentPage }
    hideOnSinglePage={ total <= 50 }
    pageSize={ pageSize }
    responsive={ false }
    showTotal={ (total, _) => {
      return i18n.t('table_total').replace('%$', `${ total }`);
    } }
    pageSizeOptions={ [
      50, 100, 150,
    ] }
    onChange={ (page, pageSize) => {
      refresh({ offset: (page - 1) * pageSize, limit: pageSize });
    } }
    onShowSizeChange={ (current, size) => {
      refresh({ offset: (current - 1) * size, limit: size });
    } }
    { ...restProps }
  />;
};